import { useRef } from 'react'
import DotsLoading from 'common-components/DotsLoading'
import { COLORS } from 'consts/colors'
import { ScrollableElementContext } from '../../contextApi'
import { AiIconTabEmptyHistory } from '../Empty'
import { AiImageHistoryTabContent } from '../Content'
import { useFetchAiImgHistoryDataOnScroll } from '../useFetchAiImgHistoryDataOnScroll'
import * as Styled from '../styled'
import { useAiImageHistory } from 'hooks/useAiImageHistory'

const GenerationHistory = () => {
  const scrollableElementRef = useRef<HTMLDivElement | null>(null)

  const { historyItems, hasData, isLoading } = useAiImageHistory()

  useFetchAiImgHistoryDataOnScroll({
    containerRef: scrollableElementRef.current
  })

  return (
    <ScrollableElementContext.Provider
      value={{
        scrollableElementRef
      }}
    >
      <Styled.AiImageHistoryContainer ref={scrollableElementRef}>
        <Styled.AiImageTabContentWrapper>
          {isLoading ? (
            <DotsLoading dotColor={COLORS.primaryDark} size="xSmall" />
          ) : hasData ? (
            <AiImageHistoryTabContent items={historyItems} />
          ) : (
            <AiIconTabEmptyHistory />
          )}
        </Styled.AiImageTabContentWrapper>
      </Styled.AiImageHistoryContainer>
    </ScrollableElementContext.Provider>
  )
}

export default GenerationHistory
